import React from 'react';
import { STAGES } from '../crmConstants';

export const PipelineMiniBar = ({ pipeline = {}, onStageClick }) => (
  <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
    {STAGES.map(stage => {
      const count = pipeline[stage.id] || 0;
      return (
        <div
          key={stage.id}
          onClick={() => onStageClick(stage.id)}
          style={{
            flex: '1 1 100px', padding: '0.5rem 0.75rem', background: '#fff',
            border: '1px solid #E5E7EB', borderRadius: 6, cursor: 'pointer',
            transition: 'border-color 0.15s ease',
          }}
          data-testid={`mini-pipeline-${stage.id.replace(/\s+/g, '-').toLowerCase()}`}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '0.7rem', fontWeight: 500, color: stage.color }}>{stage.id}</span>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '1rem', fontWeight: 700, color: 'var(--navy)' }}>
              {count}
            </span>
          </div>
        </div>
      );
    })}
  </div>
);
